export default {
  MR: 'Mr.',
  MRS: 'Mrs.',
  MISS: 'Miss',
  MS: 'Ms',
  MESSRS: 'Messrs.',
  REV: 'Rev.',
  HON: 'Hon.',
  MRMRS: 'Mr & Mrs',
  DR: 'Dr.'
}